module.exports = __webpack_public_path__ + "img/real-time04.b070cd2c.jpg";